module.exports = __webpack_public_path__ + "img/dyewm.bc0c9446.png";